import { TApplicationState } from '../../types/redux';

export function getReliableLabel(state: TApplicationState) {
  return state.newbuilding.reliableLabel;
}
